import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { sendGetClientRequest, sendPatchClientRequest } from '../../../api/helper';

// Blueprint 列表
export const getBlueprintList = createAsyncThunk('blueprint/getBlueprintList', async (parameters) => {
  let url = `/api/blueprint_template?type=${parameters.type}&page=${parameters.page}&limit=${parameters.limit}&code=${parameters.code}&parent_id=${
    parameters.parent_id ? parameters?.parent_id : null
  }`;
  if (parameters?.search) url += `&search=${parameters.search}`;

  const response = await sendGetClientRequest(url);
  return response.data;
});

export const getPolicyList = createAsyncThunk('blueprint/getPolicyList', async (parameters) => {
  let url = `/api/blueprint_template?type=${parameters.type}&page=${parameters.page}&limit=${parameters.limit}&code=${parameters.code}&parent_id=${
    parameters.parent_id ? parameters?.parent_id : null
  }`;
  if (parameters?.search) url += `&search=${parameters.search}`;

  const response = await sendGetClientRequest(url);
  return response.data;
});

export const getSubPolicyList = createAsyncThunk('blueprint/getSubPolicyList', async (parameters) => {
  let url = `/api/blueprint_template?type=${parameters.type}&page=${parameters.page}&limit=${parameters.limit}&code=${parameters.code}&parent_id=${
    parameters.parent_id ? parameters?.parent_id : null
  }`;
  if (parameters?.search) url += `&search=${parameters.search}`;

  const response = await sendGetClientRequest(url);
  return response.data;
});

export const getStrategyList = createAsyncThunk('blueprint/getStrategyList', async (parameters) => {
  let url = `/api/blueprint_template?type=${parameters.type}&page=${parameters.page}&limit=${parameters.limit}&code=${parameters.code}&parent_id=${
    parameters.parent_id ? parameters?.parent_id : null
  }`;
  if (parameters?.search) url += `&search=${parameters.search}`;

  const response = await sendGetClientRequest(url);
  return response.data;
});

export const getPlanList = createAsyncThunk('blueprint/getPlanList', async (parameters) => {
  let url = `/api/blueprint_template?type=${parameters.type}&page=${parameters.page}&limit=${parameters.limit}&code=${parameters.code}&parent_id=${
    parameters.parent_id ? parameters?.parent_id : null
  }`;
  if (parameters?.search) url += `&search=${parameters.search}`;

  const response = await sendGetClientRequest(url);
  return response.data;
});

// 編輯 Policy
export const patchPolicy = createAsyncThunk('blueprint/patchPolicy', async (parameters) => {
  const response = await sendPatchClientRequest(`/api/blueprint_template`, parameters);
  return response;
});

const blueprintSlice = createSlice({
  name: 'blueprint',
  initialState: {
    loading: false,
    success: false,
    removed: false,
    updated: false,
    uploaded: false,
    blueprint_lists: '',
    policy_lists: '',
    subpolicy_lists: '',
    strategy_lists: '',
    plan_lists: '',
    error: null,
  },
  reducers: {
    resetSuccess: (state) => {
      state.success = false;
      state.removed = false;
      state.uploaded = false;
      state.updated = false;
    },
    updateType: (state, action) => {
      state.type = action.payload;
    },
  },
  extraReducers: {
    // BLUEPRINT LISTS
    [getBlueprintList.pending]: (state) => {
      state.loading = true;
      state.success = false;
    },
    [getBlueprintList.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.loading = false;
        state.success = true;
        state.blueprint_lists = payload;
      } else {
        state.loading = false;
        state.success = false;
      }
    },
    [getBlueprintList.rejected]: (state) => {
      state.loading = false;
      state.success = false;
    },

    [getPolicyList.pending]: () => {},
    [getPolicyList.fulfilled]: (state, { payload }) => {
      if (payload) state.policy_lists = payload;
    },
    [getPolicyList.rejected]: () => {},

    [getSubPolicyList.pending]: () => {},
    [getSubPolicyList.fulfilled]: (state, { payload }) => {
      if (payload) state.subpolicy_lists = payload;
    },
    [getSubPolicyList.rejected]: () => {},

    [getStrategyList.pending]: () => {},
    [getStrategyList.fulfilled]: (state, { payload }) => {
      if (payload) state.strategy_lists = payload;
    },
    [getStrategyList.rejected]: () => {},

    [getPlanList.pending]: () => {},
    [getPlanList.fulfilled]: (state, { payload }) => {
      if (payload) state.plan_lists = payload;
    },
    [getPlanList.rejected]: () => {},

    // UPDATE POLICY
    [patchPolicy.pending]: (state) => {
      state.loading = true;
      state.updated = false;
    },
    [patchPolicy.fulfilled]: (state, { payload }) => {
      if (payload.msg === 'success') {
        state.updated = true;
      }
      state.loading = false;
    },
    [patchPolicy.rejected]: (state) => {
      state.loading = false;
      state.updated = false;
    },
  },
});

export default blueprintSlice.reducer;
export const selectBlueprint = (state) => state.blueprint;
export const { resetSuccess, updateType } = blueprintSlice.actions;
